/* unplugin-vue-components disabled */import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=5cfe2b3e&lang=scss"

const __exports__ = script;

export default __exports__